import { HttpClient } from '@shared/adapters/HttpClient';

export interface TeamChild {
  id: number;
  name: string;
}

export class TeamsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getTeamsChild(): Promise<TeamChild[]> {
    const response = await this.httpClient.get('/teams-child');
    return response.data;
  }
}
